import { Divider } from "@mantine/core";
import ListItem from "./toolbar/list-item";
import TextAlign from "./toolbar/text-align";
import TextFormat from "./toolbar/text-format";
import TextStyling from "./toolbar/text-styling";
import LinkButton from "./toolbar/link-button";
import TextUnderscore from "./toolbar/text-underscore";
import classes from "./menu-bar.module.css";
import ClearStyles from "./toolbar/clear-styles";

export default function MenuBar({ editor, language }) {
  if (!editor) {
    return null;
  }

  return (
    <div className={classes.menuBar}>
      {/* <TooltipProvider> */}
      <TextFormat editor={editor} language={language} />
      <Divider orientation="vertical" />
      <TextStyling editor={editor} language={language} />
      <TextUnderscore editor={editor} language={language} />
      {/* <Divider orientation="vertical" />
      <TextAlign editor={editor} /> */}
      <Divider orientation="vertical" />
      <ListItem editor={editor} language={language} />
      <Divider orientation="vertical" />
      <LinkButton editor={editor} language={language} />
      <Divider orientation="vertical" />
      <ClearStyles editor={editor} language={language} />
      {/* </TooltipProvider> */}
    </div>
  );
}
